var exports = {
  "i": "xcc377c0b--7a9d91--wrapper",
};

module.exports = exports;
